import { createStore } from 'redux'
import rootReducer from "../reducers";


/**
 * Create a Redux store that holds All State Data.
 */
const store = createStore(rootReducer);
export default store;